import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlatformLocation } from "@angular/common";
import { PcpItem as PcpItemV2 } from "@core/interfaces/3rdparty/pcp/v2/pcp-item";
import { PcpItem as PcpItemV3 } from "@core/interfaces/3rdparty/pcp/v3/pcp-item";

@Component({
    selector: "app-pcp-selection-modal",
    templateUrl: "./pcp-selection-modal.component.html",
    styleUrls: ["./pcp-selection-modal.component.scss"],
    standalone: false,
})
export class PcpSelectionModalComponent {
    @Output() selectionMade = new EventEmitter();
    @Output() pageChanged = new EventEmitter();
    @Input() apiVersion: "v2" | "v3" = "v3";
    @Input() pcpProviders: { total: number; items: Array<PcpItemV2 | PcpItemV3> };
    @Input()
    page = 1;

    pageSize = 10;

    public readonly translationPrefix = "common.modals.pcpModal";

    constructor(
        public activeModal: NgbActiveModal,
        private location: PlatformLocation,
    ) {
        location.onPopState(() => activeModal.close());
    }

    get shouldUseV2(): boolean {
        return this.apiVersion === "v2";
    }

    emitSelectionMade(pcpInfo) {
        this.selectionMade.emit(pcpInfo);
        this.activeModal.dismiss();
    }

    emitChangePage(page) {
        this.page = page;
        this.pageChanged.emit({
            page: page > 0 ? page - 1 : 0,
            pageSize: this.pageSize,
        });
    }
}
